import {
  Box,
  Flex,
  Image,
  Text,
  useColorMode,
  useToast,
  Modal,
  Button,
} from "native-base";
import React, { useState, useRef, useEffect } from "react";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import styles from "./styles";
import { useTheme } from "../../../../ThemeProvider";

import Api from "../../../../Api/Api";
import { useNavigation, useRoute } from "@react-navigation/native";
import Template from "../../../template/Index";
import Input from "../../../../components/Input";
import {
  FlatList,
  Modal as RNModal,
  Pressable,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View,
} from "react-native";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import { corComAlpha, corTextoSobre } from "../../../theme/cores";
import SkeletonItens from "../../../components/Skeleton/Itens";
import {
  AntDesign,
  MaterialCommunityIcons,
  Feather,
  Ionicons,
  FontAwesome,
} from "@expo/vector-icons";
import StorageUtil from "../../../../Utils";
import ModalConfirmacao from "../../../../components/ModalConfirmacao";
import { RFPercentage } from "react-native-responsive-fontsize";
import { useToastMessage } from "../../../hooks/useToastMessage";

const Historico: React.FC = () => {
  const { getCodEmpresa, configEmpresa, primaryColor } = useTheme();

  const toast = useToast();
  const navigation = useNavigation();
  const refModal = useRef<any>(null);
  const refModalConfirmacao = useRef<any>(null);
  // const route = useRoute();

  const [historico, setHistorico] = useState<any[]>([]);
  // const [pacotes_original, setPacotesOriginal] = useState<any[]>([]);
  // const [filtro, setFiltro] = useState<String>("");
  const [buscando, setBuscando] = useState<boolean>(false);
  const [agendamentoCancelar, setAgendamentoCancelar] = useState<any>({});
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa || "{}"),
  );
  const [detalhesVisiveis, setDetalhesVisiveis] = useState(false);
  const [agendamentoDetalhes, setAgendamentoDetalhes] = useState<any>({});

  const { colorMode } = useColorMode();
  const { error, success } = useToastMessage();

  useEffect(() => {
    getHistoricoCliente();
  }, []);

  async function getHistoricoCliente() {
    const value = await StorageUtil.getItem("cliente");

    if (!value) {
      return;
    }
    setBuscando(true);

    try {
      const historicoCliente = await Api.historicoCliente(
        value.id,
        getCodEmpresa,
      );

      if (!historicoCliente.status) {
        refModal.current.abrirModal("Erro ao buscar histórico");
        setBuscando(false);
        return;
      }

      setHistorico(historicoCliente.data || []);
    } catch (error) {
      refModal.current.abrirModal("Erro ao buscar histórico");
    } finally {
      setBuscando(false);
    }
  }

  function recuperarData(data: string) {
    if (!data) return { dia: "00", mes: "Jan", ano: "0000" };

    try {
      const data_formatada = new Date(`${data}T00:00:00`);
      const dia = data_formatada.getDate();
      const mes = data_formatada.getMonth() + 1;
      const ano = data_formatada.getFullYear();

      const mesExtenso = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];

      return {
        dia: dia < 10 ? `0${dia}` : dia,
        mes: mesExtenso[mes - 1] || "Jan",
        ano: ano,
      };
    } catch (error) {
      return { dia: "00", mes: "Jan", ano: "0000" };
    }
  }

  function isDataPassada(dataAgendamento: string, horario: string): boolean {
    if (!dataAgendamento || !horario) return false;

    try {
      const agora = new Date();
      const [hora, minuto] = horario.split(":");
      const dataAgend = new Date(dataAgendamento);
      dataAgend.setHours(Number(hora), Number(minuto), 0, 0);

      return dataAgend < agora;
    } catch (error) {
      return false;
    }
  }

  function formatarDataDDMMAA(data: string | undefined): string {
    if (!data) return "Data inválida";

    try {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano.substring(2)}`;
    } catch (error) {
      return "Data inválida";
    }
  }

  const renderLinha = (label: string, valor: string) => {
    const getIcon = () => {
      switch (label) {
        case "Horário":
          return (
            <AntDesign
              name="clockcircle"
              size={16}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          );
        case "Profissional":
          return (
            <AntDesign
              name="user"
              size={16}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          );
        case "Serviço":
          return (
            <AntDesign
              name="tool"
              size={16}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          );
        case "Status":
          return (
            <AntDesign
              name="checkcircle"
              size={16}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          );
        case "Valor":
          return (
            <AntDesign
              name="creditcard"
              size={16}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          );
        default:
          return null;
      }
    };

    if (label === "Status") {
      const isConfirmado = valor === "CONFIRMADO";
      const isCancelado = valor === "CANCELADO";

      return (
        <Flex direction="row" alignItems="center" style={{ marginTop: 5 }}>
          <Flex direction="row" alignItems="center" style={{ marginRight: 5 }}>
            {getIcon()}
            <Text
              style={{
                fontWeight: "bold",
                color: getConfigEmpresa.coresPWA?.corFontePrimaria || "#000",
                marginLeft: 5,
              }}
              fontSize="sm"
            >
              {label}:
            </Text>
          </Flex>
          <Box
            style={{
              marginLeft: 5,
              paddingHorizontal: 8,
              paddingVertical: 2,
              borderRadius: 12,
              backgroundColor: isConfirmado
                ? "rgba(76, 175, 80, 0.2)"
                : isCancelado
                  ? "rgba(244, 67, 54, 0.2)"
                  : "rgba(158, 158, 158, 0.2)",
            }}
          >
            <Text
              style={{
                color: isConfirmado
                  ? "rgba(76, 175, 80, 1)"
                  : isCancelado
                    ? "rgba(244, 67, 54, 1)"
                    : "rgba(158, 158, 158, 1)",
                fontWeight: "bold",
              }}
              fontSize="sm"
            >
              {valor}
            </Text>
          </Box>
        </Flex>
      );
    }

    return (
      <Flex direction="row" alignItems="center" style={{ marginTop: 5 }}>
        {getIcon()}
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={{
            fontWeight: "bold",
            color: getConfigEmpresa.coresPWA?.corFontePrimaria || "#000",
            marginLeft: 5,
          }}
          fontSize="sm"
        >
          {label}:{" "}
          <Text
            style={{
              fontWeight: "normal",
              color: getConfigEmpresa.coresPWA?.corFontePrimaria || "#000",
            }}
            fontSize="md"
          >
            {" "}
            {valor}
          </Text>
        </Text>
      </Flex>
    );
  };

  const renderLinhaModal = (
    label: string,
    valor: string,
    iconName: any,
    iconLibrary: any = AntDesign,
  ) => {
    const IconComponent = iconLibrary;

    if (label === "Status") {
      const isConfirmado = valor === "CONFIRMADO";
      const isCancelado = valor === "CANCELADO";

      return (
        <Flex direction="row" alignItems="center" mb={3}>
          <IconComponent
            name={iconName}
            size={20}
            color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            style={{ marginRight: 10 }}
          />
          <Text fontWeight="bold" mr={2}>
            {label}:
          </Text>
          <Box
            style={{
              paddingHorizontal: 8,
              paddingVertical: 2,
              borderRadius: 12,
              backgroundColor: isConfirmado
                ? "rgba(76, 175, 80, 0.2)"
                : isCancelado
                  ? "rgba(244, 67, 54, 0.2)"
                  : "rgba(158, 158, 158, 0.2)",
            }}
          >
            <Text
              style={{
                color: isConfirmado
                  ? "rgba(76, 175, 80, 1)"
                  : isCancelado
                    ? "rgba(244, 67, 54, 1)"
                    : "rgba(158, 158, 158, 1)",
                fontWeight: "bold",
              }}
              fontSize="sm"
            >
              {valor}
            </Text>
          </Box>
        </Flex>
      );
    }

    return (
      <Flex direction="row" alignItems="center" mb={3}>
        <IconComponent
          name={iconName}
          size={20}
          color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
          style={{ marginRight: 10 }}
        />
        <Text fontWeight="bold" mr={2}>
          {label}:
        </Text>
        <Text>{valor}</Text>
      </Flex>
    );
  };

  function linhaPacote(item: any) {
    const { dia, mes, ano } = recuperarData(item.data);

    return (
      <Flex style={[styles.containerFlex, {}]}>
        <Box
          style={{
            width: wp("20%"),
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#1976d2",
            borderRadius: 8,
            padding: 8,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            position: "relative",
          }}
        >
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
            }}
          />
          <Text
            style={{
              color: "white",
              fontSize: 24,
              fontWeight: "bold",
              marginBottom: 2,
            }}
          >
            {dia}
          </Text>
          <Text
            style={{
              color: "white",
              fontSize: 14,
              fontWeight: "bold",
              textTransform: "uppercase",
              marginBottom: 2,
            }}
          >
            {mes}
          </Text>
          <Text
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: 12,
            }}
          >
            {ano}
          </Text>
        </Box>

        <Box
          style={{
            width: wp("55%"),
            paddingLeft: 10,
          }}
        >
          {renderLinha("Horário", item.horario || "Não informado")}
          {renderLinha(
            "Profissional",
            item.nomeProfissional || "Não informado",
          )}
          {renderLinha("Serviço", item.servico || "Não informado")}
          {renderLinha("Status", item.status || "Não informado")}
          {renderLinha(
            "Valor",
            `R$ ${
              item.valor ? item.valor.toFixed(2).replace(".", ",") : "0,00"
            }`,
          )}
        </Box>

        <Flex
          direction="column"
          align="center"
          justify="space-between"
          style={{ width: wp("20%") }}
        >
          <TouchableOpacity
            onPress={() => {
              if (item.disabled) return;
              setAgendamentoCancelar(item);
              refModalConfirmacao.current.abrirModal();
            }}
            style={{ padding: 8 }}
            disabled={item.disabled}
          >
            <AntDesign
              name="closecircle"
              size={24}
              color={
                item.status === "CONFIRMADO" && !item.dataEPassada
                  ? "#ff0000"
                  : "rgba(255, 0, 0, 0.3)"
              }
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              setAgendamentoDetalhes(item);
              setDetalhesVisiveis(true);
            }}
            style={{ padding: 8 }}
          >
            <AntDesign
              name="eye"
              size={24}
              color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
            />
          </TouchableOpacity>
        </Flex>
      </Flex>
    );
  }

  const renderItem = ({ item, index }: any) => (
    <Box
      key={index}
      style={[
        styles.pressableItem,
        {
          // { borderColor: item.selecionado ? cor_rgba ?? 'defaultColor' : 'rgba(0, 0, 0, 0.2)',
          borderColor: getConfigEmpresa.coresPWA?.corBordaItens || "#ccc",
        }, //mais clara
      ]}
    >
      {buscando ? <SkeletonItens /> : linhaPacote(item)}
    </Box>
  );

  const renderEmptyComponent = () => (
    <Box alignItems="center" justifyContent="center" mt={5}>
      <MaterialCommunityIcons
        name="database-remove"
        size={80}
        color={getConfigEmpresa.coresPWA?.corFontePrimaria || "#000"}
        style={{ marginBottom: 10 }}
      />
      <Text
        style={{
          textAlign: "center",
          fontSize: RFPercentage(2.5),
          color: getConfigEmpresa.coresPWA?.corFontePrimaria || "#000",
        }}
      >
        Nenhum registro encontrado.
      </Text>
    </Box>
  );

  async function cancelarAgendamento() {
    if (!refModal.current) {
      return;
    }

    refModal.current.abrirLoader();

    try {
      const cancelar = await Api.cancelarAgendamento(agendamentoCancelar.id);

      if (!cancelar.status) {
        refModal.current.fecharLoader();
        refModalConfirmacao.current.fecharModal();

        error("Atenção", "Erro ao cancelar agendamento");

        return;
      }

      refModalConfirmacao.current.fecharModal();
      refModal.current.fecharLoader();
      getHistoricoCliente();

      success("Atenção", "Agendamento cancelado com sucesso");
    } catch (errors) {
      refModal.current.fecharLoader();
      refModalConfirmacao.current.fecharModal();

      error("Atenção", "Erro ao cancelar agendamento");
    }
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  function formatarValor(valor: any) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function corStatus(status: string) {
    if (status === "CONFIRMADO") return { texto: "#1E7B3C", fundo: "#E3F2E7" };
    if (status === "CANCELADO") return { texto: "#C0392B", fundo: "#FBE6E3" };
    return { texto: "#7c7c7c", fundo: "rgba(0,0,0,0.06)" };
  }

  function textoStatus(status: string) {
    if (!status) return "Não informado";
    return status.charAt(0) + status.slice(1).toLowerCase();
  }

  function textoRelativo(data: Date) {
    const hoje = new Date();
    const inicioHoje = new Date(
      hoje.getFullYear(),
      hoje.getMonth(),
      hoje.getDate(),
    );
    const dias = Math.round((data.getTime() - inicioHoje.getTime()) / 86400000);

    if (dias === 0) return "hoje";
    if (dias === 1) return "amanhã";
    if (dias === -1) return "ontem";
    if (dias > 1) return `daqui a ${dias} dias`;
    return `há ${Math.abs(dias)} dias`;
  }

  // agrupa os agendamentos por dia, mantendo a ordem que vem da API
  function agruparPorDia(lista: any[]) {
    const grupos: { data: string; itens: any[] }[] = [];

    for (const item of lista) {
      const grupo = grupos.find((g) => g.data === item.data);
      if (grupo) {
        grupo.itens.push(item);
      } else {
        grupos.push({ data: item.data, itens: [item] });
      }
    }

    return grupos;
  }

  function abrirCancelamento(item: any) {
    if (item.disabled) return;
    setAgendamentoCancelar(item);
    refModalConfirmacao.current.abrirModal();
  }

  function renderCabecalhoDia(dataTexto: string) {
    if (!dataTexto) return null;

    const data = new Date(`${dataTexto}T00:00:00`);

    return (
      <View style={stylesNovo.cabecalhoDia}>
        <View style={[stylesNovo.caixaDia, { backgroundColor: corPrincipal }]}>
          <RNText style={[stylesNovo.mesCaixa, { color: corTextoPrincipal }]}>
            {MESES[data.getMonth()].substring(0, 3).toUpperCase()}
          </RNText>
          <RNText style={[stylesNovo.diaCaixa, { color: corTextoPrincipal }]}>
            {data.getDate()}
          </RNText>
        </View>
        <View>
          <RNText style={stylesNovo.semanaDia}>
            {DIAS_SEMANA[data.getDay()]}
          </RNText>
          <RNText style={stylesNovo.dataDia}>
            {data.getDate()} de {MESES[data.getMonth()].toLowerCase()} ·{" "}
            {textoRelativo(data)}
          </RNText>
        </View>
      </View>
    );
  }

  function renderCardAgendamento(item: any, index: number) {
    const status = corStatus(item.status);
    const podeCancelar = !item.disabled;

    return (
      <View key={item.id ?? index} style={[stylesNovo.card, sombraCard]}>
        <View style={stylesNovo.corpoCard}>
          <RNText style={stylesNovo.horario}>{item.horario || "--:--"}</RNText>

          <View style={stylesNovo.divisorVertical} />

          <View style={{ flex: 1 }}>
            <RNText style={stylesNovo.servico} numberOfLines={1}>
              {item.servico || "Não informado"}
            </RNText>
            <View style={stylesNovo.linhaProfissional}>
              <View
                style={[
                  stylesNovo.inicialProfissional,
                  { backgroundColor: corComAlpha(corPrincipal, 0.12) },
                ]}
              >
                <RNText
                  style={[stylesNovo.textoInicial, { color: corPrincipal }]}
                >
                  {String(item.nomeProfissional || "?").charAt(0).toUpperCase()}
                </RNText>
              </View>
              <RNText style={stylesNovo.profissional} numberOfLines={1}>
                {item.nomeProfissional || "Não informado"}
              </RNText>
            </View>
          </View>

          <View style={{ alignItems: "flex-end", gap: 6 }}>
            <RNText style={stylesNovo.valor}>{formatarValor(item.valor)}</RNText>
            <View style={[stylesNovo.chipStatus, { backgroundColor: status.fundo }]}>
              <View
                style={[stylesNovo.pontoStatus, { backgroundColor: status.texto }]}
              />
              <RNText style={[stylesNovo.textoStatus, { color: status.texto }]}>
                {textoStatus(item.status)}
              </RNText>
            </View>
          </View>
        </View>

        <View style={stylesNovo.linhaAcoes}>
          <TouchableOpacity
            style={stylesNovo.acao}
            onPress={() => {
              setAgendamentoDetalhes(item);
              setDetalhesVisiveis(true);
            }}
          >
            <RNText style={[stylesNovo.textoAcao, { color: corPrincipal }]}>
              Ver detalhes
            </RNText>
          </TouchableOpacity>

          <View style={stylesNovo.divisorAcoes} />

          <TouchableOpacity
            style={stylesNovo.acao}
            disabled={!podeCancelar}
            onPress={() => abrirCancelamento(item)}
          >
            <RNText
              style={[
                stylesNovo.textoAcao,
                { color: VERMELHO, opacity: podeCancelar ? 1 : 0.35 },
              ]}
            >
              Cancelar
            </RNText>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  function renderLinhaDetalhe(rotulo: string, valor: React.ReactNode) {
    return (
      <View style={stylesNovo.linhaDetalhe}>
        <RNText style={stylesNovo.rotuloDetalhe}>{rotulo}</RNText>
        {typeof valor === "string" ? (
          <RNText style={stylesNovo.valorDetalhe}>{valor}</RNText>
        ) : (
          valor
        )}
      </View>
    );
  }

  function renderDetalhesNovo() {
    const item = agendamentoDetalhes || {};
    const status = corStatus(item.status);

    return (
      <RNModal
        visible={detalhesVisiveis}
        transparent
        animationType="fade"
        onRequestClose={() => setDetalhesVisiveis(false)}
      >
        <Pressable
          style={stylesNovo.overlay}
          onPress={() => setDetalhesVisiveis(false)}
        >
          <Pressable style={stylesNovo.folha}>
            <View style={stylesNovo.alca} />
            <RNText style={stylesNovo.tituloDetalhes}>
              Detalhes do agendamento
            </RNText>

            {renderLinhaDetalhe("Data", formatarDataDDMMAA(item.data))}
            {renderLinhaDetalhe("Horário", item.horario || "Não informado")}
            {renderLinhaDetalhe(
              "Profissional",
              item.nomeProfissional || "Não informado",
            )}
            {renderLinhaDetalhe("Serviço", item.servico || "Não informado")}
            {renderLinhaDetalhe(
              "Status",
              <View
                style={[stylesNovo.chipStatus, { backgroundColor: status.fundo }]}
              >
                <View
                  style={[
                    stylesNovo.pontoStatus,
                    { backgroundColor: status.texto },
                  ]}
                />
                <RNText
                  style={[stylesNovo.textoStatus, { color: status.texto }]}
                >
                  {textoStatus(item.status)}
                </RNText>
              </View>,
            )}
            {renderLinhaDetalhe("Valor", formatarValor(item.valor))}

            <View style={stylesNovo.botoesDetalhes}>
              <TouchableOpacity
                style={[stylesNovo.botaoDetalhe, stylesNovo.botaoFechar]}
                onPress={() => setDetalhesVisiveis(false)}
              >
                <RNText style={[stylesNovo.textoBotaoDetalhe, { color: CORES.titulo }]}>
                  Fechar
                </RNText>
              </TouchableOpacity>

              <TouchableOpacity
                disabled={item.disabled}
                style={[
                  stylesNovo.botaoDetalhe,
                  {
                    backgroundColor: "#FBE6E3",
                    opacity: item.disabled ? 0.4 : 1,
                  },
                ]}
                onPress={() => {
                  setDetalhesVisiveis(false);
                  abrirCancelamento(item);
                }}
              >
                <RNText style={[stylesNovo.textoBotaoDetalhe, { color: VERMELHO }]}>
                  Cancelar agendamento
                </RNText>
              </TouchableOpacity>
            </View>
          </Pressable>
        </Pressable>
      </RNModal>
    );
  }

  function renderConfirmacaoCancelamento(textoBotao: string) {
    return (
      <ModalConfirmacao
        titulo={"Atenção"}
        ref={refModalConfirmacao}
        mensagem={"Tem certeza que deseja cancelar o agendamento?"}
        textoBotaoPositivo={textoBotao}
        onConfirmPositivo={() => {
          if (refModal.current) {
            cancelarAgendamento();
          }
        }}
      />
    );
  }

  if (!utilizaLayoutLegado) {
    const grupos = agruparPorDia(historico);
    const total = historico.length;

    return (
      <TemplateEtapas
        ref={refModal}
        rotuloEtapa="Área do cliente"
        titulo="Meus agendamentos"
        subtitulo={
          buscando
            ? ""
            : `${total} ${total === 1 ? "horário marcado" : "horários marcados"}`
        }
        ocultarFechar
        ocultarRodape
        onVoltarClick={() => navigation.goBack()}
      >
        {buscando ? (
          <SkeletonItens />
        ) : total === 0 ? (
          <View style={stylesNovo.vazio}>
            <Feather name="calendar" size={40} color={CORES.subtitulo} />
            <RNText style={stylesNovo.textoVazio}>
              Você ainda não tem agendamentos.
            </RNText>
          </View>
        ) : (
          grupos.map((grupo, indice) => (
            <View key={grupo.data ?? indice} style={stylesNovo.grupo}>
              {renderCabecalhoDia(grupo.data)}
              {grupo.itens.map((item, i) => renderCardAgendamento(item, i))}
            </View>
          ))
        )}

        {renderDetalhesNovo()}
        {renderConfirmacaoCancelamento("Sim, cancelar")}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Meus Agendamentos"}
      messageAlerta="Nesta tela você pode visualizar os seus agendamentos"
      semBotaoProximo
      ocultarBotaoCancelar
      onBotaoVoltarClick={() => {
        navigation.goBack();
      }}
      ref={refModal}
    >
      <Box style={styles.mainContainer}>
        <FlatList
          data={historico}
          renderItem={renderItem}
          ListEmptyComponent={
            buscando ? <SkeletonItens /> : renderEmptyComponent
          }
          keyExtractor={(item, index) => index.toString()}
          contentContainerStyle={{
            width: wp("98%"),
          }}
        />
      </Box>

      <Modal
        isOpen={detalhesVisiveis}
        onClose={() => setDetalhesVisiveis(false)}
      >
        <Modal.Content maxWidth="400px">
          <Modal.CloseButton />
          <Modal.Header>Detalhes do Agendamento</Modal.Header>
          <Modal.Body>
            {agendamentoDetalhes && (
              <>
                {renderLinhaModal(
                  "Data",
                  formatarDataDDMMAA(agendamentoDetalhes.data),
                  "calendar",
                  AntDesign,
                )}
                {renderLinhaModal(
                  "Horário",
                  agendamentoDetalhes.horario || "Não informado",
                  "clockcircle",
                  AntDesign,
                )}
                {renderLinhaModal(
                  "Profissional",
                  agendamentoDetalhes.nomeProfissional || "Não informado",
                  "user",
                  AntDesign,
                )}
                {renderLinhaModal(
                  "Serviço",
                  agendamentoDetalhes.servico || "Não informado",
                  "scissors",
                  FontAwesome,
                )}
                {renderLinhaModal(
                  "Status",
                  agendamentoDetalhes.status || "Não informado",
                  "checkcircle",
                  AntDesign,
                )}
                {renderLinhaModal(
                  "Valor",
                  `R$ ${
                    agendamentoDetalhes.valor
                      ? agendamentoDetalhes.valor.toFixed(2)
                      : "0,00"
                  }`,
                  "creditcard",
                  AntDesign,
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Flex
              direction="row"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Button.Group space={2}>
                <Button
                  variant="solid"
                  colorScheme="blueGray"
                  onPress={() => setDetalhesVisiveis(false)}
                >
                  Fechar
                </Button>
                <Button
                  onPress={() => {
                    setDetalhesVisiveis(false);
                    setAgendamentoCancelar(agendamentoDetalhes);
                    refModalConfirmacao.current.abrirModal();
                  }}
                  isDisabled={agendamentoDetalhes.disabled}
                  colorScheme="red"
                >
                  Cancelar Agendamento
                </Button>
              </Button.Group>
            </Flex>
          </Modal.Footer>
        </Modal.Content>
      </Modal>

      {renderConfirmacaoCancelamento("Confirmar Agendamento")}
    </Template>
  );
};

const VERMELHO = "#C0392B";

const DIAS_SEMANA = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
];

const MESES = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const stylesNovo = StyleSheet.create({
  grupo: {
    marginBottom: 10,
  },
  cabecalhoDia: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginBottom: 12,
  },
  caixaDia: {
    width: 46,
    height: 46,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  mesCaixa: {
    fontSize: 10,
    fontWeight: "800",
    letterSpacing: 1,
  },
  diaCaixa: {
    fontSize: 18,
    lineHeight: 20,
    fontWeight: "800",
  },
  semanaDia: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  dataDia: {
    fontSize: 12,
    color: CORES.subtitulo,
    marginTop: 1,
  },
  card: {
    marginBottom: 12,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
    overflow: "hidden",
  },
  corpoCard: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 14,
  },
  horario: {
    fontSize: 20,
    fontWeight: "800",
    color: CORES.titulo,
    minWidth: 58,
  },
  divisorVertical: {
    width: 1,
    alignSelf: "stretch",
    backgroundColor: CORES.borda,
  },
  servico: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  linhaProfissional: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
  },
  inicialProfissional: {
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  textoInicial: {
    fontSize: 10,
    fontWeight: "800",
  },
  profissional: {
    flexShrink: 1,
    fontSize: 12,
    color: CORES.subtitulo,
  },
  valor: {
    fontSize: 14,
    fontWeight: "800",
    color: CORES.titulo,
  },
  chipStatus: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 10,
  },
  pontoStatus: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  textoStatus: {
    fontSize: 11,
    fontWeight: "700",
  },
  linhaAcoes: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderTopColor: CORES.borda,
  },
  acao: {
    flex: 1,
    paddingVertical: 12,
    alignItems: "center",
  },
  divisorAcoes: {
    width: 1,
    backgroundColor: CORES.borda,
  },
  textoAcao: {
    fontSize: 13,
    fontWeight: "700",
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
    textAlign: "center",
  },
  overlay: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  folha: {
    width: "100%",
    maxWidth: 560,
    backgroundColor: CORES.card,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    paddingHorizontal: 20,
    paddingTop: 10,
    paddingBottom: 24,
  },
  alca: {
    alignSelf: "center",
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: "rgba(0,0,0,0.12)",
    marginBottom: 16,
  },
  tituloDetalhes: {
    fontSize: 20,
    fontWeight: "800",
    color: CORES.titulo,
    marginBottom: 10,
  },
  linhaDetalhe: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: CORES.borda,
  },
  rotuloDetalhe: {
    fontSize: 13,
    color: CORES.subtitulo,
  },
  valorDetalhe: {
    flexShrink: 1,
    textAlign: "right",
    fontSize: 14,
    fontWeight: "700",
    color: CORES.titulo,
  },
  botoesDetalhes: {
    flexDirection: "row",
    gap: 10,
    marginTop: 18,
  },
  botaoDetalhe: {
    flex: 1,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  botaoFechar: {
    backgroundColor: "rgba(0,0,0,0.05)",
  },
  textoBotaoDetalhe: {
    fontSize: 14,
    fontWeight: "700",
  },
});

export default Historico;
